import { gql } from '@apollo/client';

export const DOCUMENT_PARTNER_EXTRA_INFORMATION_UPDATED = gql`
  subscription partnerExtraInfoUpdated($documentId: Int!, $siteId: Int!, $partnerId: Int!) {
    partnerExtraInfoUpdated(documentId: $documentId, siteId: $siteId, partnerId: $partnerId) {
      documentId
      siteId
      partnerId
      sectionName
      extraInformationId
      jsonData
    }
  }
`;

export const DOCUMENT_PARTNER_EXTRA_INFORMATION_INVALIDATED = gql`
  subscription partnerExtraInfoInvalidated($documentId: Int!, $siteId: Int!, $partnerId: Int!) {
    partnerExtraInfoInvalidated(documentId: $documentId, siteId: $siteId, partnerId: $partnerId) {
      documentId
      siteId
      partnerId
    }
  }
`;
